const leaseOptions = [
    {
        key: 0,
        value: 'Less Than 10',
        label: 'Less Than 10',
    },
    {
        key: 1,
        value: '11-100',
        label: '11-100',
    },
    {
        key: 2,
        value: '101-250',
        label: '101-250',
    },
    {
        key: 3,
        value: '251-500',
        label: '251-500',
    },
    {
        key: 4,
        value: '501-1000',
        label: '501-1000',
    },
    {
        key: 5,
        value: 'Over 1000',
        label: 'Over 1000',
    },
]

export default leaseOptions